module.exports = __webpack_public_path__ + "components/weather-icon/static/daythunderstorm-v2-91768fdccbfc36e5ceeeb8fc931c14eb.svg";